import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import IllegalDumpList from '@/components/illegal-dumps/list'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function IllegalDumpsView() {

    const title = 'Hlášení černých skládek'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box px={2.5} pt={2.5} pb={1}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <MunicipalityPermissionGate>
                    <IllegalDumpList />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default IllegalDumpsView
